const primary = '#502C1E';

export default {
  primary,
}
